<template>
	<modal class="modal-change-role" :hideFooter="true" @close="close" v-if="show">
		<div slot="header">
			<h3>{{ $t('roleList') }}</h3>
			<div class="select-role-info mt-2" v-if="roles.length > 0">{{ $t('youHaveSeveralRoleOnThisEvent') }}</div>
		</div>
		<div slot="body">
			<div class="role-list">
				<div class="role-item" :class="selectedRoleClass(role)" v-for="(role, index) in roles" :key="index" @click="setSelectedRole(role)">
					<div class="role-item__selected inline-item">
						<template v-if="selectedRole === role">
							<i class="material-icons">check</i>
						</template>
					</div>
					<div class="role-item__name inline-item">{{ roleLabel(role) }}</div>
				</div>
			</div>
			<div class="modal-body-footer p-3 mt-0">
				<div class="text-center">
					<button type="button" class="btn btn-lg btn-secondary btn-save raised" @click="save">
						{{ $t('proceed') }}
					</button>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Modal from './Modal.vue';

export default {
	name: 'ModalRoleChange',
	components: {
		Modal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			selectedRole: '',
			clickedCount: 0,
			tmpSelected: null,
		};
	},
	computed: {
		...mapGetters({
			participant: 'now/participant',
			currentRole: 'now/currentRole',
		}),
		roles() {
			return JSON.parse(this.participant.roles);
		},
	},
	methods: {
		...mapActions({
			setCurrentRole: 'now/setCurrentRole',
		}),
		close() {
			this.$emit('close');
		},
		save() {
			this.setCurrentRole(this.selectedRole);
			this.$emit('close');
		},
		selectedRoleClass(role) {
			return this.selectedRole === role ? 'active' : '';
		},
		setSelectedRole(role) {
			this.clickedCount++;
			this.selectedRole = role;

			// Change event selected and reset counter
			if (this.tmpSelected && this.tmpSelected !== role) this.clickedCount = 1;
			this.tmpSelected = this.selectedRole;

			// Handle double click
			if (this.clickedCount >= 2) {
				this.clickedCount = 0;
				this.save();
			}
		},
		roleLabel(role) {
			let label = this.$t(role);
			if (role === 'participants') label = this.$t('Participants page');
			return label;
		},
	},
	watch: {
		show(value) {
			if (value) this.selectedRole = this.currentRole;
		},
	},
};
</script>
<style lang="scss">
</style>
